import React, {useState} from 'react'
import {observer} from 'mobx-react'
import {MapPinIcon} from '../../../components/icons'
import {Box, Button, Flex, Text} from '../../../vanilla'
import {useBasketStore, useCustomerStore} from '../../../store/hooks/useStore'
import {YourDelivery} from '../../book-delivery/partials/your-delivery'

export const ChangeAddress = observer(() => {
    const {shippingAddress} = useBasketStore()
    const {addresses} = useCustomerStore()
    const [addressToggled, setAddressToggled] = useState<boolean>(false)

    const selectedAddress = addresses?.find(
    (address) => address.addressId === shippingAddress?.c_customerAddressID
    )
    const addressDisplay = [
    [selectedAddress?.address1, selectedAddress?.address2].filter(Boolean).join(', '),
    selectedAddress?.postalCode
    ]
    .filter(Boolean)
    .join(' ... ')

    return (
    <Box backgroundColor="white" data-test-selector="select-delivery-address">
        <Box
        display="flex"
        flexDirection={['column', 'row']}
        alignItems={['flex-start', 'center']}
        justifyContent="space-between"
        gap={['8px', '16px']}
        padding={['12px', '16px']}
        data-test-selector="select-delivery-address-summary"
        >
        <Flex direction="column" flexWrap="wrap" gap="8px">
            <Text weight="bold">We'll deliver to:</Text>
            <Box display="flex" alignItems={['flex-start', 'center']} gap="8px">
            <MapPinIcon
                aria-hidden="true"
                flexShrink="0"
                viewBox="0 0 16 16"
                boxSize={['20px', '16px']}
                style={{marginTop: '2px'}}
            />
            <Text lineHeight="short" data-test-selector="select-delivery-address-value">
                {addressDisplay || 'No address selected'}
            </Text>
            </Box>
        </Flex>
        <Button
            type="button"
            variant="link"
            size="sm"
            additionalTextProps={{color: 'accent1'}}
            style={{textDecoration: 'none', flexShrink: 0}}
            onClick={() => setAddressToggled((toggled) => !toggled)}
            aria-expanded={addressToggled}
            data-test-selector="select-delivery-change-address"
        >
            Change
        </Button>
        </Box>

        {addressToggled && (
        <Box data-test-selector="select-delivery-address-editor">
            <YourDelivery />
        </Box>
        )}
    </Box>
    )
})
